import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getGranteesAdmin } from "../../core/service/grantees.service";

// material
import { styled } from "@mui/material/styles";
import { Card, CardHeader } from "@mui/material";

// ----------------------------------------------------------------------

const CHART_HEIGHT = 372;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled("div")(({ theme }) => ({
  height: 300,
  marginTop: theme.spacing(5),
  "& .apexcharts-canvas svg": { height: CHART_HEIGHT },
  "& .apexcharts-canvas svg,.apexcharts-canvas foreignObject": {
    overflow: "visible"
  },
  "& .apexcharts-legend": {
    height: LEGEND_HEIGHT,
    alignContent: "center",
    position: "relative !important",
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

// ----------------------------------------------------------------------

export default function ProgramChartAdmin() {
  const [grantees, setGrantees] = useState({});
  const { entities } = grantees;
  const getGrantees = async () => {
    const data = await getGranteesAdmin();
    setGrantees(data);
  };
  useEffect(() => {
    getGrantees();
  }, []);

  const stdPostDoc = entities?.filter((e) => e.role_id === 1).length || 0;
  const stdPhd = entities?.filter((e) => e.role_id !== 1).length || 0;
  const CHART_DATA = [stdPostDoc, stdPhd];

  const chartOptions = {
    colors: ["#0070C0", "#1CD1A1"],
    labels: ["Post doc", "Phd"],
    legend: { show: false },
    dataLabels: {
      enabled: false,
      formatter: (val) => {
        return val + "%";
      },
      dropShadow: { enabled: true }
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total",
              color: "#373d3f",
              formatter: (val) => {
                return val.globals.seriesTotals.reduce((a, b) => {
                  return a + b;
                }, 0);
              }
            }
          }
        }
      }
    }
  };

  return (
    <Card>
      <CardHeader title="Program" />
      <ChartWrapperStyle dir="ltr">
        <ReactApexChart
          type="donut"
          series={CHART_DATA}
          options={chartOptions}
          height={280}
        />
      </ChartWrapperStyle>
    </Card>
  );
}
